var React = require('react');

function IconMobileMenuDarkInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 4H23","stroke":"#240041","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M8 12L23 12","stroke":"#240041","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M1 20H23","stroke":"#240041","strokeWidth":"2","strokeLinecap":"round","key":2})]);
}

IconMobileMenuDarkInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconMobileMenuDarkInline;

IconMobileMenuDarkInline.default = IconMobileMenuDarkInline;
